"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONNECTOR_OPTIONS = exports.REASON_OPTIONS = exports.HUM_CAPITAL_TEMPLATE_FILES_URL = exports.DETAILED_CONNECTOR_REQUEST_FORM_BASE_URL = void 0;
exports.DETAILED_CONNECTOR_REQUEST_FORM_BASE_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSeuGiZAadMPpftyPh0Ft2iAwB0vBtKi6BLFBjgXQD6DavtjmA';
exports.HUM_CAPITAL_TEMPLATE_FILES_URL = 'https://hum-assets-production.s3.amazonaws.com/Hum+Capital+Template.zip';
exports.REASON_OPTIONS = [
    {
        label: 'I don’t see my connector',
        value: 'I don’t see my connector',
    },
    {
        label: "I don't have login credentials",
        value: "I don't have login credentials",
    },
    {
        label: 'My software doesn’t represent my finances',
        value: 'My software doesn’t represent my finances',
    },
    {
        label: 'I use more than one accounting service',
        value: 'I use more than one accounting service',
    },
    {
        label: 'There’s a bug or problem connecting',
        value: 'There’s a bug or problem connecting',
    },
    {
        label: 'Other',
        value: 'Other',
    },
];
exports.CONNECTOR_OPTIONS = [
    {
        label: 'Zoho Books',
        value: 'Zoho Books',
    },
    {
        label: 'QuickBooks Online',
        value: 'QuickBooks Online',
    },
    {
        label: 'QuickBooks Desktop',
        value: 'QuickBooks Desktop',
    },
    {
        label: 'ClearBooks',
        value: 'ClearBooks',
    },
    {
        label: 'Exact',
        value: 'Exact',
    },
    {
        label: 'FreeAgent',
        value: 'FreeAgent',
    },
    {
        label: 'FreshBooks',
        value: 'FreshBooks',
    },
    {
        label: 'Sage 50',
        value: 'Sage 50',
    },
    {
        label: 'Sage 200cloud',
        value: 'Sage 200cloud',
    },
    {
        label: 'Sage Business Accounting',
        value: 'Sage Business Accounting',
    },
    {
        label: 'Sage Intact',
        value: 'Sage Intact',
    },
    {
        label: 'Pandle',
        value: 'Pandle',
    },
    {
        label: 'MYOB Essentials',
        value: 'MYOB Essentials',
    },
    {
        label: 'MYOB AccountRight',
        value: 'MYOB AccountRight',
    },
    {
        label: 'Microsoft Dynamics 365',
        value: 'Microsoft Dynamics 365',
    },
    {
        label: 'KashFlow',
        value: 'KashFlow',
    },
    {
        label: 'Wave',
        value: 'Wave',
    },
];
//# sourceMappingURL=constants.js.map